import React, { useState } from 'react';
//import { Document, Page } from 'react-pdf';
//import { pdfjs } from 'react-pdf';
import{HomeProps} from './Home.tsx'
import { Button, Card, Elevation,Slider, Overlay,H4 } from "@blueprintjs/core";
import Quiz from 'react-quiz-component';
import './cardquizz.css';


const quiz1={"appLocale": {
    "landingHeaderText": "<questionLength> Questions",
    "question": "Question",
    "startQuizBtn": "Démarrer le Quiz",
    "resultFilterAll": "Tous",
    "resultFilterCorrect": "Correct",
    "resultFilterIncorrect": "Incorrect",
    "nextQuestionBtn": "Prochaine",
    "resultPagePoint":"Votre score est de <correctPoints> sur <totalPoints>.",
    "singleSelectionTagText": 'Choix unique',
    "multipleSelectionTagText": 'Selection multiple',
    "pickNumberOfSelection": 'Choix <numberOfSelection>',
    "resultPageHeaderText": "Le Quizz est complet. Vous avez <correctIndexLength> sur <questionLength> questions."
  } ,
      "quizTitle": "Questionnaire Gérontif",
      "quizSynopsis": "Anglais",
      "questions": [
        {
          "question": "What is answer correct?",
          "questionType": "text",
          "answers": [
            "Brian's Car?",
            "Car's Brian"
          ],
          "correctAnswer": "1",
          "messageForCorrectAnswer": "Oui le possesseur est devant",
          "messageForInorrectAnswer": "Non le possesseur doit être devant",
          "point": "5",
          "explanation": "Revoir la vidéo"
        },
        {
          "questionType": "text",
          "answers": [
            "I dont't know?",
            "His dog",
            "His car",
            "His dog'name look like a car"
          ],
          "question": "In the audio document, Brian talk about what?",
          "correctAnswer": "2",
          "point": "5",
        },
        {
          "questionType": "text",
          "questionPic": "/upload/media/07.jpg",
          "answers": [
            "two",
            "three",
            "four",
            "five"
          ],
          "question": "How many students?",
          "correctAnswer": "3",
          "point": "5",
        }
      ]
    
  } 
  
  export  class CardQuizz extends React.Component  <HomeProps> {
    state = {
      name: '',
      file:'',
      zoom:0.5,
      largeur:'660px',
      isOpenPdf:'none',
      numPages:0,
      force_width:'660px',
      showcontenu:'block',
      parent_height:680
    }  
    
    constructor(props) {
          super(props);
         // pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
          this.setState({file:props.url_video})
         // this.handleChange = this.handleChange.bind(this);
        }
    componentDidMount () { 
      this.setState({file:this.props.url_video})
         
    }
   
    componentDidUpdate(prevProps, prevState) {
      
    }
    onFileChange=function (event) {
      this.setState({file:event.target.files[0]})
    }
  
     onDocumentLoadSuccess=function(ev) {
      console.log("onDocumentLoadSuccess");
      console.log(ev._pdfInfo.numPages);
      this.setState({numPages:ev._pdfInfo.numPages})
      this.setState({isOpenPdf:'none'});
      //setNumPages(nextNumPages);
    }
    renderLoader=function renderLoader(ev)
    {
      console.log("ici");
      console.log(ev);
      console.log(this);
    }
    private getChangeHandler(key: string) {
      return (value: number) => this.setState({ [key]: value });
  }
     render() {
      
      const {youtube_frame,url_video,title_document,description,objectif,isnotdocument,navFiles,state,isnotconnected,menuVisibility,isOpenSign,usernickname,isOpenLogin,handleOpenVisio,handleOpen,handleClose,handleChange,handleSendCnx,handleSelectionChange,handlehandleSelectionGetLoginSelectionChangeLogin,handleOpenLogin,handleCloseLogin,handleChangeLogin,handleSendCnxLogin}=this.props;
  
      return(
       <div style={{display:isnotdocument,width:this.state.force_width,margin:4,zIndex:1}}>
       
       <Card style={{width:this.state.force_width,margin:4,objectFit:'contain'}} interactive={true} elevation={Elevation.TWO}>
       <div style={{textAlign: 'right'}}>
      <Button onClick={(ev)=>{ev.preventDefault();this.setState({parent_height:"80px"});this.setState({showcontenu:"none"});}} className={Classes.OUTLINED } icon="minimize" title="Réduire" />
      <Button onClick={(ev)=>{ev.preventDefault();this.setState({parent_height:"480px"});this.setState({showcontenu:"block"});}} className={Classes.OUTLINED } icon="maximize" title="Augmenter" />
      </div>
       <h3><a href="">{title_document}</a></h3>
       <p><b>{description}</b></p>
       <p>{objectif}</p>
       <Overlay isOpen={this.state.isOpenDelete} className={Classes.OVERLAY_SCROLL_CONTAINER} {...this.props} {...this.state}>
                    <div style={{ color: '#444', background: '#fff', padding: '50px', width: '50%',margin: '5% 25%'}}>
                        <H4>Effacer le document {this.props.title_document}</H4>
                       
                        <p style={{marginTop:20}}>
                           Etes-vous sûr de vouloir effacer le document {this.props.title_document} ?
                        </p>
                                              
                        <br />
                        <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button intent={Intent.PRIMARY} onClick={(ev)=>{ev.preventDefault();this.setState({isOpenDelete:false});}}>Annuler</Button>
                            <Button intent={Intent.DANGER} onClick={(ev)=>{
                              ev.preventDefault();this.setState({isOpenDelete:false});
                              
                              var xhr = new XMLHttpRequest();
                              xhr.overrideMimeType("application/json");
                              var that=this;
                              xhr.open('GET','/api/public/deldocument?id_document='+this.props.id_document)
                              this.setState({file:''})
                              xhr.setRequestHeader("Content-Type", "application/json");

                              //send the form data
                              xhr.send();

                                    xhr.onreadystatechange = function() {
                                        if (xhr.readyState == XMLHttpRequest.DONE) {
                                                      
                                        if(xhr.status==200) 
                                        { 
                                        
                                          console.log(xhr.responseText);
                                          //that.props.onchildrenevent();
                                          that.props.LoadDataDocumentsDirect(-1)
                                          return;
                                          var jsonResponse = JSON.parse(xhr.responseText);
                                          console.log(jsonResponse);
                                          
                                          
                                          
                                        }
                                        if(xhr.status==404) {console.log( {message:"erreur"}); }
                                        if(xhr.status==500) {console.log( {message:"erreur"}); }
                                        
                                        }
                                      
                                    }
                              
                              
                              
                              
                              }} style={{ margin: "" }}>
                                Valider
                            </Button>
                            
                            
                        </div>
                    </div>
     </Overlay>
         {/* <Button style={{margin:'5px 0 5px 60px'}} onClick={(ev)=>{ev.preventDefault();if(this.state.zoom==0.5){this.setState({isOpenPdf:'flex'});this.setState({zoom:1.5});} else {this.setState({zoom:0.5});this.setState({isOpenPdf:'none'});}}}>{this.state.zoom==0.5 ? "Ouvrir" : "Fermer" }</Button>*
          <Slider
                      min={0.2}
                      max={3}
                      stepSize={0.1}
                      labelStepSize={10}
                      onChange={this.getChangeHandler("zoom")}
                      value={this.state.zoom}
                      vertical={false}
                  />*/}
      <div style={{display:this.state.showcontenu}}>
       <Quiz quiz={quiz1}/>      
       </div>  
      </Card>
      
       </div>);
  }
  }
  